var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareC(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3959",
    "data-name": "Rectangle 3959",
    width: 18,
    height: 18,
    transform: "translate(17199 -3694)",
    fill: "#03dac6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_416",
    "data-name": "Mask Group 416",
    transform: "translate(-17199 3694)",
    clipPath: ""
  }, /*#__PURE__*/React.createElement("path", {
    id: "__TEMP__SVG__",
    d: "M16.294,14.622a2.474,2.474,0,0,0-1.772.679L8.029,11.547a3.059,3.059,0,0,0,.091-.633,3.008,3.008,0,0,0-.091-.633l6.4-3.708a2.718,2.718,0,1,0-.863-1.991,3.008,3.008,0,0,0,.091.633l-6.4,3.708A2.733,2.733,0,0,0,5.4,8.2a2.688,2.688,0,0,0-2.679,2.713A2.734,2.734,0,0,0,7.3,12.9l6.448,3.754a2.259,2.259,0,0,0-.091.588,2.634,2.634,0,1,0,2.634-2.623Z",
    transform: "translate(17197.133 -3695.868)",
    fill: "#03dac6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareC);
export default __webpack_public_path__ + "static/media/share_c.4868fbd166ed3b88094b042c0e65f968.svg";
export { ForwardRef as ReactComponent };